import { render, staticRenderFns } from "./ClassReviewDetails.vue?vue&type=template&id=44038f31&scoped=true"
import script from "./ClassReviewDetails.vue?vue&type=script&lang=js"
export * from "./ClassReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ClassReviewDetails.vue?vue&type=style&index=0&id=44038f31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44038f31",
  null
  
)

export default component.exports